export default function ErrorPage() {
  return (
    <p className="ion-padding" style={{textAlign: 'center'}}>
      Something went wrong. This error has been logged for review by our dev team.
      <br/>
      <a href="/">Reload</a>
    </p>
  );
}
